import { FormlyExtension } from '@ngx-formly/core';

export const showValidationExtension: FormlyExtension = {
  prePopulate(field): void {
    if (field.validation?.show === undefined) {
      field.validation = { ...field.validation, show: true };
    }
  },
};
